import { useState } from "react";
import { Loader2 } from "lucide-react";

interface RejectOrderSectionProps {
  onReject: (reason: string) => void;
  rejecting?: boolean;
  onCancel: () => void;
}

const RejectOrderSection: React.FC<RejectOrderSectionProps> = ({ onReject, rejecting, onCancel }) => {
  const [reason, setReason] = useState("");

  return (
    <div className="mt-4 p-4 rounded-xl border border-red-200 bg-red-50/50 animate-fadeIn">
      <label className="text-xs font-semibold text-red-600 block mb-2">Reason for Rejection *</label>
      <textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Please provide a reason for rejecting this order..."
        className="w-full px-3 py-2.5 text-xs border border-red-200 rounded-lg outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100 resize-none h-20 transition-all bg-white"
      />
      <div className="flex justify-end gap-2 mt-3">
        <button
          className="px-4 py-2 rounded-lg text-xs font-semibold border border-slate-200 text-slate-600 bg-white hover:bg-slate-50 transition-colors cursor-pointer"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="px-4 py-2 rounded-lg text-xs font-semibold bg-red-500 text-white hover:bg-red-600 transition-colors border-none cursor-pointer disabled:opacity-40 flex items-center gap-2"
          disabled={!reason.trim() || rejecting}
          onClick={() => onReject(reason)}
        >
          {rejecting && <Loader2 size={12} className="animate-spin" />}
          Confirm Reject
        </button>
      </div>
    </div>
  );
};

export default RejectOrderSection;
